import styled from "@emotion/styled";

const ErrorText = styled.span`
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;

    color: #E70000;
`

export default ErrorText;